
import { Component, Vue } from "vue-property-decorator";
import FacilityList from "@/views/FacilityList.vue";

@Component({
  components: {
    FacilityList
  }
})
export default class Home extends Vue {
}
